import { ETestIds } from 'shared/constants/testIds';

/** Совпадает с `top` у sticky-списка предложений в ShortOffersList. */
export const OFFERS_LIST_STICKY_TOP_OFFSET = 42;

const getOffersScrollTarget = (): Element | null =>
  document.querySelector(`[data-testid=${ETestIds.ShortOffersList}]`) ||
  document.querySelector(`[data-testid=${ETestIds.ShortOffersEmpty}]`) ||
  document.querySelector(`[data-testid=${ETestIds.OffersListing}]`);

export const scrollToOffersListing = ({ isDesktop }: { isDesktop: boolean }) => {
  const element = getOffersScrollTarget();

  if (!element) {
    return;
  }

  if (isDesktop) {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - OFFERS_LIST_STICKY_TOP_OFFSET,
      behavior: 'smooth',
    });

    return;
  }

  element.scrollIntoView({ behavior: 'smooth' });
};
